import * as Icons from 'lucide-react';
import { SYNC_STATUS } from '../lib/status';

export default function SyncBadge({ status = 'synced', className = '' }) {
  const cfg = SYNC_STATUS[status] || SYNC_STATUS.synced;
  const Icon = Icons[cfg.icon] || Icons.Circle;
  return (
    <span
      data-testid={`sync-badge-${status}`}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-mono uppercase tracking-wider ${cfg.cls} ${className}`}
    >
      <Icon className={`h-3 w-3 ${status === 'syncing' ? 'spin-slow' : ''}`} />
      {cfg.label}
    </span>
  );
}
